<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12 p-md-6">
            <div class="card p-fluid">
                <h5>{{ $t('Receipt.list.Download Excel')}}</h5>
                <div class="p-field">
                    <label for="name1">{{ $t('Receipt.list.Download Excel Type')}}</label>
                    <Dropdown :class="`${error.category1 ? 'p-invalid' : ''}`" v-model="selectedGroup" :options="groupCategory" optionLabel="name" placeholder="그룹 유형 선택" />
                    <div class="text-red">{{ error.category1 }}</div>
                </div>
                <Button label="Excel Download" @click="exceldownload" icon="pi pi-download" class="p-button" />
            </div>
        </div>

        <div class="p-col-12 p-md-6">
            <div class="card p-fluid">
                <h5 class="bold">{{ $t('Receipt.list.Upload Excel')}}</h5>
                <div class="p-field">
                    <label for="name1">{{ $t('Receipt.list.Upload Excel Type')}}</label>
                    <Dropdown :class="`${error.category ? 'p-invalid' : ''}`" v-model="category" :options="groupCategory" optionLabel="name" placeholder="select category type" />
                    <div class="text-red">{{ error.category }}</div>
                </div>
                <div class="p-field">
                    <label for="name1">{{ $t('Receipt.list.Upload File')}}</label>
                    <div :class="`${error.file ? 'custom-select-invalid' : 'custom-select'}`">
                        <span v-if="!fileName">{{ $t('button.select_file') }}</span>
                        <span v-else>{{ fileName }}</span>
                        <input type="file" class="select-file" v-on:change="onFileChange" />
                        <Button :label="$t('button.select_file')" class="SelectBtn n-wrap" />
                    </div>
                    <!-- <div v-show="upload" class="text-gray">{{ $t('DFC.add.message') }}</div> -->
                    <div class="text-red" v-show="render1">{{ $t('validation.invalidFile') }}</div>
                    <div class="text-red">{{ error.file }}</div>
                    <img id="frame" src width="100px" height="100px" />
                </div>
                <div><Button label="Excel Upload" @click="addDfc" icon="pi pi-upload" class="p-button" /></div>
            </div>
        </div>
    </div>
</template>
<script>
import ReceiptService from '../../service/API/ReceiptService';
import validateuploadExcel from '../../validations/receipt/uploadExcel';
import validatedownloadExcel from '../../validations/receipt/downloadExcel';
import axios from 'axios';
export default {
    name: 'AddBanner',
    // props: ['dog', 'image'],
    data() {
        return {
            selectedGroup: '',
            groupCategory: [
                { name: 'Shop Name', code: 'shop_name' },
                { name: 'Product name', code: 'product_name' },
            ],
            category: '',
            render1: false,
            upload: true,
            success: '',
            errors: '',
            totalrecord: '',
            errorArray: '',
            render: false,
            render2: false,
            file: '',
            fileName: '',
            fileExtension: '',
            formData: new FormData(),
            error: {},
        };
    },
    created() {
        this.receiptService = new ReceiptService();
    },
    methods: {
        resetdfcadd() {
            this.error.file = '';
            this.render1;
            this.file = '';
            this.fileName = '';
            this.upload = true;
            this.render = false;
            this.render2 = false;
            this.render1 = false;
        },
        onFileChange(e) {
            this.formData.delete('file');
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.file = files[0];
            var allowedExtensions = /(\.xlsx)$/i;
            if (!allowedExtensions.exec(this.file.name)) {
                this.render1 = true;
                this.upload = false;
                this.error.file = '';
                return false;
            } else {
                this.render1 = false;
                this.upload = true;
                this.fileName = this.file.name;
                this.formData.append('file', files[0]);
                this.error.file = '';
            }
            this.fileExtension = this.fileName.replace(/^.*\./, '');
            console.log(this.fileName);
        },
        exceldownload() {
            let vcheckData = {
                category1: this.selectedGroup.code == undefined ? '' : 'something',
            };
            const { isInvalid, error } = validatedownloadExcel(vcheckData);
            if (isInvalid) {
                this.error = error;
                console.log(error);
            } else {
                    this.receiptService.groupExceldDownload(this.selectedGroup.code).then((response) => {
                        console.log(response);
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', this.selectedGroup.code == 'shop_name' ? 'shopNameGroup.xlsx' : 'productNameGroup.xlsx'); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                    });
            }
        },
        addDfc() {
            this.formData.delete('excel_upload_type');
            console.log(this.category);
            this.upload = false;
            let vcheckData = {
                file: this.file == '' ? '' : 'something',
                category: this.category.code == undefined ? '' : 'something',
            };
            const { isInvalid, error } = validateuploadExcel(vcheckData);
            if (isInvalid) {
                this.error = error;
                console.log(error);
            } else {
                this.formData.append('excel_upload_type', this.category.code);
                return axios.post('/report/receipt/upload', this.formData).then((data) => {
                    console.log(data);
                    this.$toast.add({ severity: 'success', summary: 'Upload Success', detail: `성공적으로 업로드되었습니다.`, life: 3000 });
                    // if (data.data.data.errorArray.length == 0) {
                    //     console.log('success');
                    //     this.render2 = true;
                    //     this.render = false;
                    //     this.success = data.data.data.success;
                    //     this.errors = data.data.data.error;
                    //     this.totalrecord = data.data.data.totalRecord;
                    // } else {
                    //     this.render2 = true;
                    //     this.success = data.data.data.success;
                    //     this.errors = data.data.data.error;
                    //     this.errorArray = data.data.data.errorArray;
                    //     this.render = true;
                    //     this.totalrecord = data.data.data.totalRecord;
                    //     if (this.success == 0) {
                    //         this.$toast.add({ severity: 'error', summary: '거절되었습니다', detail: '등록된 정보가 없습니다.', life: 3000 });
                    //     } else {
                    //         this.$toast.add({ severity: 'info', summary: '확인', detail: `${this.success} 명의 DFC가 업로드 되었습니다.`, life: 3000 });
                    //     }
                    // }
                });
            }
        },
    },
};
</script>

<style scoped>
.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}
.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}
.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}
.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}
.SelectBtn {
    max-width: 100px;
}
.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
